import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const CrmDynamicObjectsQuery = registerQuery({
  fieldName: 'crmDynamicObjects',
  fetcher: ({
    crmObjectTypeId,
    propertyForDynamicPageSlug
  }) => http.get(`crm/v3/objects/${crmObjectTypeId}`, {
    query: {
      properties: [propertyForDynamicPageSlug]
    }
  })
});
const useCrmDynamicObjects = ({
  crmObjectTypeId,
  propertyForDynamicPageSlug,
  crmObjectId
}) => {
  const skip = !crmObjectTypeId || !propertyForDynamicPageSlug || !crmObjectId;
  const {
    data,
    loading,
    error
  } = useQuery(CrmDynamicObjectsQuery, {
    variables: {
      crmObjectTypeId,
      propertyForDynamicPageSlug: propertyForDynamicPageSlug
    },
    skip
  });
  const crmDynamicPageSlug = useMemo(() => {
    var _data$crmDynamicObjec, _data$crmDynamicObjec2;
    if (skip || loading || error || (data === null || data === void 0 || (_data$crmDynamicObjec = data.crmDynamicObjects) === null || _data$crmDynamicObjec === void 0 ? void 0 : _data$crmDynamicObjec.results.length) === 0) {
      return undefined;
    }
    const objectForDynamicPage = data === null || data === void 0 || (_data$crmDynamicObjec2 = data.crmDynamicObjects) === null || _data$crmDynamicObjec2 === void 0 ? void 0 : _data$crmDynamicObjec2.results.find(crmDynamicPageObject => crmDynamicPageObject.id === crmObjectId);
    return objectForDynamicPage === null || objectForDynamicPage === void 0 ? void 0 : objectForDynamicPage.properties[propertyForDynamicPageSlug];
  }, [data, propertyForDynamicPageSlug, crmObjectId, skip, loading, error]);
  return useMemo(() => ({
    crmDynamicPageSlug,
    crmDynamicObjects: data === null || data === void 0 ? void 0 : data.crmDynamicObjects,
    crmDynamicObjectsRequestLoading: loading,
    crmDynamicObjectsRequestError: error
  }), [data, crmDynamicPageSlug, loading, error]);
};
export default useCrmDynamicObjects;